import React from 'react'
const Footer = () => {
  return (
    <footer className='footer'>
      Copyright &#169; 2023 &nbsp;<span style={{color:"#17a2b8"}}>Varsha Chaubey</span>. &nbsp;All rights received.
    </footer>
  )
}

export default Footer
